import React from 'react';
import EtoLogout from 'components/Logout/EtoLogout';
import ApricotLogout from 'components/Logout/ApricotLogout';
import * as S from 'components/Logout/Logout.style';
import { useParams } from 'react-router-dom';
import { IntegrationType } from 'helpers/integration/IntegrationType';

const Logout = () : React.ReactElement => {
    type ProductType = {
        productType: string;
      };

    const { productType } = useParams<ProductType>();
    return (
        <S.Background>
            { productType === IntegrationType.Apricot.toLowerCase() ? <ApricotLogout /> : <EtoLogout /> }
        </S.Background>

    );
};

export default Logout;
